import { ElementRef, ForwardedRef, forwardRef } from 'react';
import {
    Body,
    Cancel,
    Close,
    Description,
    DialogBody,
    DialogBodyProps,
    DialogCancel,
    DialogCancelProps,
    DialogClose,
    DialogCloseProps,
    DialogContent as DialogContentPrimitive,
    DialogContentProps as DialogContentPrimitiveProps,
    DialogDescriptionProps,
    DialogHeader,
    DialogHeaderProps,
    DialogOverlay,
    DialogOverlayProps,
    DialogPortal,
    DialogPortalProps,
    DialogProps,
    DialogRoot,
    DialogTitleProps,
    DialogTrigger,
    DialogTriggerProps,
    Header,
    Overlay,
    Portal,
    Root,
    Title,
    Trigger,
} from '@givebutter/primitives/dialog';

interface DialogContentProps extends DialogContentPrimitiveProps {}
const DialogContent = forwardRef(
    (
        { onInteractOutside: onInteractOutsideConsumer, ...rest }: DialogContentProps,
        forwardedRef: ForwardedRef<ElementRef<typeof DialogContentPrimitive>>,
    ) => {
        return (
            <DialogContentPrimitive
                ref={forwardedRef}
                onInteractOutside={e => {
                    onInteractOutside(e);
                    onInteractOutsideConsumer?.(e);
                }}
                {...rest}
            />
        );
    },
);

const onInteractOutside: NonNullable<DialogContentProps['onInteractOutside']> = e => {
    const isFocusIn = e.detail.originalEvent.type === 'focusin';
    const possibleTarget = e.currentTarget as HTMLElement | null;
    const possibleToast = possibleTarget?.closest(`#toast-viewport`);
    const possibleTinyNode = possibleTarget?.closest('.tox');

    if (isFocusIn || possibleToast || possibleTinyNode) {
        e.preventDefault();
    }
};

const Content = DialogContent;

export {
    DialogRoot,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogHeader,
    DialogTrigger,
    DialogPortal,
    DialogOverlay,
    DialogCancel,
    //
    Root,
    Body,
    Header,
    Content,
    Trigger,
    Close,
    Portal,
    Overlay,
    Title,
    Description,
    Cancel,
    //
    onInteractOutside,
};

export type {
    DialogProps,
    DialogPortalProps,
    DialogTriggerProps,
    DialogContentProps,
    DialogCloseProps,
    DialogBodyProps,
    DialogHeaderProps,
    DialogTitleProps,
    DialogDescriptionProps,
    DialogOverlayProps,
    DialogCancelProps,
};
